import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Badge, Menu, Icon, Table, Button, Modal, Spin, Row, Col, Select, DatePicker, Input, Pagination, Form, InputNumber, Checkbox } from 'antd';
import cn from 'classnames';
import { getClassOrders } from 'data/class';
import classes from '../styles/Promocode.module.scss';
import { browserHistory, Link } from 'react-router';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
// import update from 'immutability-helper';

import { getContents } from 'data/content';
import { isEmpty, merge, get, map } from 'lodash';
import { useDispatch } from 'react-redux';
import { formatNumber } from 'utils/formatting';
import { TableHelper, exportAsExcel } from 'helpers/Table';
import moment from 'moment';
import Utils from 'utils/utils';

import callApi from 'helpers/callApi';
import { formItemLayout } from 'constants/layout';
const remainingThreshold = 3;
const pageLimit = 20;
const FormItem = Form.Item;
const Option = Select.Option;
const disabledDate = (current) => {
  // Can not select days before today and today
  return current && current < moment().subtract(1, 'day').endOf('day');
};

const PromocodeList = ({ classroom, form, BreadCrumb }) => {
  const [promocodes, setPromocodes] = useState([]);
  const [promocodeCount, setPromocodeCount] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [sortBy, setSortby] = useState('');
  const [tags, setTags] = useState([]);

  const [query, setQuery] = useState({
    page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [isShowPromocodeModal, setIsShowPromocodeModal] = useState(false);
  const [selectedCode, setSelectedCode] = useState({ isFree: false });
  const [errors, setErrors] = useState({});
  const [testResultPrice, setTestResultPrice] = useState(0);

  const fetchPromocodeList = async (query = {}) => {
    setLoading(true);
    const _promocodes = await callApi({ url: `/promocodes`, query });
    setLoading(false);
    setPromocodes(_promocodes.results);
    setPromocodeCount(_promocodes.count);
  };
  const getTags = async () => {
    const _tags = await getContents('tags');
    setTags(_tags);
  };
  useEffect(() => {
    fetchPromocodeList();
    getTags();
  }, []);

  // if (query.type === 'fb') {
  //   Router.push('/');
  // }
  if (!promocodes) {
    return <div></div>;
  }

  const onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    let sortBy;
    if (order === 'descend') {
      sortBy = `-${field}`;
    } else if (order === 'ascend') {
      sortBy = field;
    }
    const newQuery = { ...query, sortBy: sortBy };
    // setSortby(sortBy);
    setQuery(newQuery);
    fetchPromocodeList(newQuery);
  };

  const onChangePage = (page) => {
    const newQuery = { ...query, page: page };
    setQuery(newQuery);
    fetchPromocodeList(newQuery);
    // this.getOrders(_.merge(this.getCurrentQuery(), { page }));
    // this.setState({
    //   page,
    //   selectedRowKeys: [],
    // });
  };

  const onInputSearch = (event) => {
    setQuery({ ...query, q: event.target.value });
  };

  const onSearchInputPress = (event) => {
    if (event.charCode === 13) {
      fetchPromocodeList(query);
      return;
    }
  };

  const content = promocodes.map((singleContent, key) => {
    singleContent.key = key;
    singleContent.durationString = 'formatThaiDuration(singleContent.duration)';
    return singleContent;
  });

  const renderPromocodeModal = () => {
    const handlePromocodeChange = (e, x) => {
      console.log(e, x);
      setSelectedCode({
        ...selectedCode,
        [e.target.name]: e.target.value,
      });

      setErrors({
        ...errors,
        [e.target.name]: false,
      });
    };

    const validate = () => {
      const _errors = {};
      if (!selectedCode.code) {
        _errors.code = true;
      }
      if (!selectedCode.discountPercentage) {
        _errors.discountPercentage = true;
      }
      if (!selectedCode.minOrder) {
        _errors.minOrder = true;
      }

      if (!selectedCode.maxDiscount) {
        _errors.maxDiscount = true;
      }
      if (!selectedCode.capacity) {
        _errors.capacity = true;
      }
      if (!selectedCode.expiredDate) {
        _errors.expiredDate = true;
      }

      setErrors(_errors);
      return isEmpty(_errors);
    };

    const handleEditcode = async () => {
      if (validate()) {
        try {
          setLoading(true);
          await callApi(selectedCode.isEdit ? { url: `/promocodes/${selectedCode._id}`, body: selectedCode, method: 'put' } : { url: `/promocodes`, body: selectedCode });
          await fetchPromocodeList(query);
          setLoading(false);
          setIsShowPromocodeModal(false);
        } catch (err) {
          alert(err);
          setLoading(false);
        }
      }
      console.log('error');
    };

    const deleteCode = async () => {
      try {
        setLoading(true);
        await callApi({ url: `/promocodes/${selectedCode._id}`, method: 'delete' });
        await fetchPromocodeList(query);
        setLoading(false);
        setIsShowPromocodeModal(false);
      } catch (err) {
        alert(err);
        setLoading(false);
      }
    };

    const allTags = map(tags, (tag) => tag.value);
    const selectedTags = (selectedCode.tags || []).map((tag) => ({
      key: tag,
      label: tag,
    }));

    // const renderPageTopMenu() {
    //   return (
    //     <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.selectedStatus]} mode="horizontal" className={classes.menu}>
    //       {this.classStatuses &&
    //         this.classStatuses.map((singleClass) => (
    //           <Menu.Item key={singleClass.value} className={classes.dashRight}>
    //             <div>{singleClass.label} </div>
    //           </Menu.Item>
    //         ))}
    //     </Menu>
    //   );
    // }

    return (
      <Modal
        title={'Promo Code List'}
        visible={isShowPromocodeModal}
        onCancel={() => setIsShowPromocodeModal(false)}
        footer={[
          selectedCode.isEdit ? (
            <Button key="back" type="danger" size="large" onClick={() => deleteCode()}>
              Delete
            </Button>
          ) : (
            <Button key="back" type="" size="large" onClick={() => setIsShowPromocodeModal(false)}>
              Cancel
            </Button>
          ),
          <Button key="submit" type="primary" size="large" loading={loading} onClick={handleEditcode}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={handleEditcode}>
          <FormItem {...formItemLayout} label="Code" hasFeedback validateStatus={errors.code ? 'error' : ''}>
            <Input placeholder="DISCOUNT200, DISCOUNT100" name="code" onChange={handlePromocodeChange} value={selectedCode.code} disabled={selectedCode.isEdit} />
          </FormItem>

          <FormItem {...formItemLayout} label="%Discount" hasFeedback validateStatus={errors.discountPercentage ? 'error' : ''}>
            <InputNumber
              placeholder=""
              name="discountPercentage"
              onChange={(value) =>
                handlePromocodeChange({
                  target: {
                    name: 'discountPercentage',
                    value: value,
                  },
                })
              }
              value={selectedCode.discountPercentage}
              disabled={selectedCode.isEdit}
            />
          </FormItem>
          <FormItem {...formItemLayout} label="Min Price" hasFeedback validateStatus={errors.minOrder ? 'error' : ''}>
            <InputNumber
              placeholder=""
              name="minOrder"
              onChange={(value) =>
                handlePromocodeChange({
                  target: {
                    name: 'minOrder',
                    value: value,
                  },
                })
              }
              value={selectedCode.minOrder}
              disabled={selectedCode.isEdit}
            />
          </FormItem>
          <FormItem {...formItemLayout} label="Max Discount" hasFeedback validateStatus={errors.maxDiscount ? 'error' : ''}>
            <InputNumber
              placeholder=""
              name="maxDiscount"
              onChange={(value) =>
                handlePromocodeChange({
                  target: {
                    name: 'maxDiscount',
                    value: value,
                  },
                })
              }
              value={selectedCode.maxDiscount}
              disabled={selectedCode.isEdit}
            />
          </FormItem>
          <FormItem {...formItemLayout} label="Capacity" hasFeedback validateStatus={errors.capacity ? 'error' : ''}>
            <InputNumber
              placeholder=""
              name="capacity"
              onChange={(value) =>
                handlePromocodeChange({
                  target: {
                    name: 'capacity',
                    value: value,
                  },
                })
              }
              value={selectedCode.capacity}
            />
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="Expired Date" hasFeedback validateStatus={errors.expiredDate ? 'error' : ''}>
            <DatePicker
              placeholder=""
              onChange={(momentDates) =>
                handlePromocodeChange({
                  target: {
                    name: 'expiredDate',
                    value: momentDates,
                  },
                })
              }
              disabledDate={disabledDate}
              value={selectedCode.expiredDate ? moment(selectedCode.expiredDate) : moment()}
            />
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="Only New User">
            <Checkbox
              onChange={(e) =>
                handlePromocodeChange({
                  target: {
                    name: 'onlyNewUser',
                    value: e.target.checked,
                  },
                })
              }
              checked={selectedCode.onlyNewUser}
            ></Checkbox>
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="tags">
            <Select
              mode="multiple"
              // style={{ width: '100%' }}
              labelInValue
              searchPlaceholder="tags"
              // value={}
              onChange={(value) =>
                handlePromocodeChange({
                  target: {
                    name: 'tags',
                    value: value,
                  },
                })
              }
              defaultValue={selectedTags || []}
            >
              {allTags.map((tag) => (
                <Option key={tag}>{tag}</Option>
              ))}
            </Select>
          </FormItem>

          <FormItem {...formItemLayout} label="Remark">
            <Input onChange={handlePromocodeChange} value={selectedCode.remark} name="remark" />
          </FormItem>

          <div className={classes.testSection}>
            <h4 className="bold">TEST Promo Code</h4>
            <FormItem {...formItemLayout} label="Order Price" hasFeedback validateStatus={errors.capacity ? 'error' : ''}>
              <InputNumber
                placeholder=""
                name="orderPrice"
                onChange={(value) => {
                  const price = value;
                  console.log(value, selectedCode, price >= selectedCode.minOrder);
                  if (selectedCode.minOrder === 0 || price >= selectedCode.minOrder) {
                    let discount = (price * selectedCode.discountPercentage) / 100;
                    discount = discount > selectedCode.maxDiscount ? selectedCode.maxDiscount : discount;
                    setTestResultPrice(price - discount);
                    return;
                  }
                  setTestResultPrice(price);
                }}
              />
            </FormItem>

            <div className="ant-row ant-form-item">
              <div className="ant-col ant-form-item-label ant-col-xs-24 ant-col-sm-6 bold">
                <label>Result Price</label>
              </div>
              <div className={cn('ant-col ant-form-item-label ant-col-xs-24 ant-col-sm-18', classes.resultPriceContainer)}>
                <span className={classes.resultPrice}>{testResultPrice}</span>
              </div>
            </div>
          </div>

          {/* <FormItem {...formItemLayout} label="Description">
            <Input placeholder="" name="description" onChange={handlePromocodeChange} value={selectedCode.vid} disabled={selectedCode.isEdit} />
          </FormItem> */}
        </Form>
      </Modal>
    );
  };

  return (
    <div>
      <div className="page-header">{BreadCrumb}</div>
      <Spin tip="Loading" size="large" spinning={!!loading}>
        <div className="content">
          <div>
            <div className="text-right">
              <Button
                type={'primary'}
                onClick={() => {
                  setIsShowPromocodeModal(true);
                  setSelectedCode({ expiredDate: moment().add(2, 'week').startOf('day') });
                  // setVimeoId(undefined);
                }}
                style={{ marginLeft: 10, marginBottom: 15 }}
              >
                <Icon type="plus"></Icon>
                Add new promocodes
              </Button>
            </div>
          </div>
          <div>
            <div className={classes.searchContainer}>
              <Input prefix={<Icon type="search" />} placeholder="พิมพ์รหัสที่ต้องการค้นหา" onKeyPress={(e) => onSearchInputPress(e)} onChange={(e) => onInputSearch(e)} />
            </div>
            <Table
              columns={columns}
              dataSource={content}
              bordered
              pagination={false}
              onChange={onTableChange}
              scroll={{ x: 1000 }}
              onRow={(record, index) => {
                return {
                  onClick: () => {
                    setSelectedCode({ ...record, isEdit: true });

                    setIsShowPromocodeModal(true);
                  },
                };
              }}
            />
            <Pagination className={cn(classes.pagination, 'text-right')} current={query.page} onChange={onChangePage} defaultPageSize={pageLimit} total={promocodeCount} />
          </div>
        </div>
      </Spin>
      {renderPromocodeModal()}
    </div>
  );
};

export default connect((state) => ({}), {})(PromocodeList);

const columns = [
  {
    ...TableHelper.defaultColumn('Code', 'code'),
    render: (value, record) => {
      return <div>{value}</div>;
    },
    width: 100,
  },
  {
    ...TableHelper.percentColumn('%Disc', 'discountPercentage'),
    sorter: true,
  },
  {
    ...TableHelper.priceColumn('Min. Price', 'minOrder'),
    sorter: true,
  },
  {
    ...TableHelper.priceColumn('Max. Disc', 'maxDiscount'),
    sorter: true,
  },
  {
    ...TableHelper.integerColumn('Capacity', 'capacity'),
    sorter: true,
  },
  {
    ...TableHelper.defaultColumn('Remaining', 'remaining'),
    render: (value, record) => formatNumber(record.capacity - record.usedCount, '0,0'),
    sorter: true,
  },
  {
    ...TableHelper.dateColumn('Create Date', 'createdAt'),
    sorter: true,
  },
  {
    ...TableHelper.dateColumn('Exp. Date', 'expiredDate'),
    sorter: true,
  },

  {
    ...TableHelper.defaultColumn('Remark', 'remark'),
  },
];
